<template>
  <div class="order-detail">
    <van-swipe-cell v-for="(item, index) in list" :key="index" :title="item.goodsName">
      <van-card :thumb="item.picPath">
        <template #thumb>
          <template v-if="item.picPath">
            <img :src="item.picPath" alt="" />
          </template>
          <template v-else>
            <van-icon name="photo-o" />
          </template>
        </template>
        <template #title>
          <div class="block">
            商品名称
            <p>
              {{ item.goodsName }} <span class="status">{{ getOrderType(item.orderFlg, item.goodsTypeId, item.paymentFlag) }}</span>
            </p>
          </div>
          <div class="block">
            商品单价
            <div v-if="item.priceHoliday">
              <p>
                周一至周五 <span>{{ item.price }}</span>
              </p>
              <p>
                周六、周日、法定节日 <span>{{ item.priceHoliday }}</span>
              </p>
            </div>
            <div v-else>
              <p>{{ item.price }}</p>
            </div>
          </div>
        </template>
        <template #footer>
          <h3>购买日期及数量</h3>
          <template v-for="(sub, index) in item.subOrders">
            <div :key="sub.subOrderId">
              <van-cell title="单元格" value="内容">
                <template #title>{{ sub.saleDate && sub.saleDate.split(' ')[0] }}<span v-if="moment(sub.saleDate && sub.saleDate.split(' ')[0]).valueOf() > moment().valueOf()">预售</span></template>
                <template>x{{ sub.goodsNumber }}</template>
              </van-cell>
              <template v-if="index === item.subOrders.length - 1">
                <van-cell title="单元格">
                  <template #title>共{{ item.count }}件商品</template>
                  <template>
                    <span v-if="item.orderFlg === 5">
                      {{ sub.deliverType !== '自取' ? (sub.postnumber ? `EMS:${sub.postnumber}` : '') : sub.deliverType + '（客服电话010-65368820）' }}
                    </span>
                  </template>
                </van-cell>
                <van-cell value="内容" class="btns" v-if="item.orderFlg === 4">
                  <template>
                    <van-button :disabled="!gteCurrentTime(sub.saleDate)" :color="gteCurrentTime(sub.saleDate) ? '#ff5757' : '#999'" @click="remindSendOutGoods(item)"> 提醒发货 </van-button>
                  </template>
                </van-cell>
              </template>
            </div>
          </template>
        </template>
      </van-card>
    </van-swipe-cell>
  </div>
</template>

<script>
  import moment from 'moment'
  import Cookie from 'js-cookie'
  export default {
    data() {
      return {
        list: [1],
        loading: false,
        finished: false,
        refreshing: false
      }
    },
    created() {
      let { orderId } = this.$route.query
      this.getRetailGoodsOrderInfo(orderId)
    },
    computed: {
      /**
       * todo 是否大于等于当前时间
       */
      gteCurrentTime() {
        return (time) => {
          return moment().valueOf() >= moment(time && time.split(' ')[0]).valueOf()
        }
      },
      /**
       * todo 状态转换
       * @description 如下：
       * 零售商品
       * orderFlag:0 已订阅， orderFlag=6  待付款， orderFlag=7 已超时，orderFlag=4 待发货，orderFlag=5 已发货 orderFlag=3 已删除
       * 非零售商品
       * 报卡：orderFlag：1 已确认
       * 非报卡：orderFlag：0 待确认，（orderFlag=1 and paymentFlag=0) 待付款，（orderFlag=1 and paymentFlag=1) 已确认
       */
      getOrderType() {
        return (type, goodsTypeId, paymentFlag) => {
          let res = ''
          // 零售
          if (goodsTypeId === 4) {
            switch (type) {
              case 0:
                res = '已订阅'
                break
              case 3:
                res = '已删除'
                break
              case 6:
                res = '待付款'
                break
              case 4:
                res = '待发货'
                break
              case 5:
                res = '已发货'
                break
              case 7:
                res = '已超时'
                break

              default:
                res = ''
                break
            }
          } else {
            // 非零售
            // 报卡
            if (goodsTypeId === 1) {
              switch (type) {
                case 1:
                  res = '已确认'
                  break
              }
            } else {
              // 非报卡
              switch (type) {
                case 0:
                  res = '待确认'
                  break
                case 1:
                  res = paymentFlag ? '已确认' : '待支付'
                  break
              }
            }
          }
          return res
        }
      }
    },
    methods: {
      moment,
      /**
       * todo 提醒发货
       */
      remindSendOutGoods(record) {
        let { orderId, subOrders } = record
        let remind = Cookie.get('remind' + orderId) ? JSON.parse(Cookie.get('remind' + orderId)) : undefined
        if (remind) {
          this.$toast('提醒消息已发送成功')
          return
        }
        let params = {
          orderId,
          subOrderIds: subOrders.map((item) => item.subOrderId).join(',')
        }
        this.$api.userCentered.remindSendOutGoods(params).then((res) => {
          let { message } = res
          this.$toast(message)
          let nowTime = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
          Cookie.set('remind' + orderId, true, { expires: nowTime })
        })
      },
      /**
       * todo 获取订单详情信息
       */
      getRetailGoodsOrderInfo(orderId) {
        let params = {
          orderId,
          islist: 1
        }
        this.$api.goodList.getRetailGoodsOrderInfo(params).then((res) => {
          let list = []
          let { result } = res
          if (result && JSON.stringify(result) !== {}) {
            let { mainOrder, subOrders, goodsInfo } = result
            // 如果订单已删除 提示
            if (goodsInfo.delFlag) {
              this.$toast('商品已下架')
            }
            let getLastTimeBefore = []
            let getLastTimeAfter = []
            subOrders.forEach((item) => {
              if (moment(item.saleDate).valueOf() <= moment(mainOrder.lastupTime).valueOf()) {
                getLastTimeBefore.push(item)
              } else {
                getLastTimeAfter.push(item)
              }
            })

            // 列表公用头
            let goodsInfoHeader = {
              price: goodsInfo.price,
              priceHoliday: goodsInfo.priceHoliday,
              typeId: goodsInfo.typeId,
              goodsName: goodsInfo.goodsName,
              picPath: goodsInfo.picPath,
              orderId: mainOrder.orderId,
              paymentFlag: mainOrder.paymentFlag,
              goodsTypeId: mainOrder.goodsTypeId,
              remind: false
            }
            // 大于订单日期之前的打包包裹
            if (getLastTimeBefore.length) {
              list.push({
                ...goodsInfoHeader,
                subOrders: getLastTimeBefore,
                count:
                  getLastTimeBefore.length > 1
                    ? getLastTimeBefore.reduce((total, item) => {
                        return (total.goodsNumber ? total.goodsNumber : total) + item.goodsNumber
                      })
                    : getLastTimeBefore[0].goodsNumber,
                postnumber: getLastTimeBefore[0].postnumber,
                orderFlg: getLastTimeBefore[0].orderFlg
              })
            }
            // 正常包裹
            getLastTimeAfter.forEach((item) => {
              list.push({ ...goodsInfoHeader, subOrders: [item], count: item.goodsNumber, postnumber: item.postnumber, orderFlg: item.orderFlg })
            })
            this.list = list
          }
        })
      },
      onLoad() {
        setTimeout(() => {
          if (this.refreshing) {
            this.list = []
            this.refreshing = false
          }

          for (let i = 0; i < 10; i++) {
            this.list.push(this.list.length + 1)
          }
          this.loading = false

          if (this.list.length >= 40) {
            this.finished = true
          }
        }, 1000)
      },
      onRefresh() {
        // 清空列表数据
        this.finished = false

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        this.onLoad()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .order-detail {
    padding: 10px;

    .van-card {
      padding: 0.5rem 0.5rem;
      margin-bottom: 10px;
      .van-card__thumb {
        width: 5rem;
        height: 5rem;
        box-shadow: 0 0 3px #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        color: #d9d9d9;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .van-card__content {
        p,
        div.block {
          margin: 0;
          line-height: 2;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }
        div.block {
          div,
          p {
            flex: 0.95;
          }
        }
        .status {
          color: #ff5757;
        }
      }
      .van-card__footer {
        h3 {
          font-size: 0.7rem;
          margin: 0.5rem 0;
        }
        text-align: left;
        .van-cell {
          padding: 0.5rem 0.5rem;
          font-size: 0.7rem;
          .van-cell__title span {
            margin-left: 1rem;
            font-size: 0.5rem;
            color: #ff5757;
          }
          .van-cell__value {
            color: #000;
            flex: 1.5;
          }
          &.btns .van-cell__value {
            text-align: right;
            .van-button {
              font-size: 0.78rem;
              height: auto;
              padding: 0.3rem 0.5rem;
            }
          }
        }
      }
    }
  }
</style>
